import { AppRoutes } from '@repo/web-utils/app-routes'
import { decodeHtmlEntities } from 'utils/decode-html-entities'
import { addOrReplaceLocaleInUrl } from 'cf-i18n/helpers'
import { useLocale } from 'next-intl'

import { useTrendingNowPpeProductsQuery } from '@web/gen/cf'
import type { ProductCardProduct } from './product-card-product-type'

export const useTrendingNowProductsQuery = (limit = 12, offset = 0) => {
  const locale = useLocale()

  return useTrendingNowPpeProductsQuery(
    {
      limit,
      offset,
    },
    {
      select: data => {
        const products: ProductCardProduct[] = data.legacyProductsListPPEProducts.products.map(
          product => {
            return {
              id: product.id.toString(),
              name: decodeHtmlEntities(product.title),
              image: product.image || '',
              author: product.author?.name || '',
              price: product.regularPrice || 0,
              salePrice: product.salePrice || 0,
              favoriteCount: product.favoriteCount || 0,
              href: addOrReplaceLocaleInUrl(`${AppRoutes.PRODUCT}${product.slug}`, locale),
              isLegacy: true,
              category: {
                id: product.productMainCategory?.id
                  ? product.productMainCategory.id.toString()
                  : '',
                title: product.productMainCategory?.title || '',
                slug: product.productMainCategory?.slug || '',
              },
            }
          },
        )

        return {
          products,
          meta: data.legacyProductsListPPEProducts.meta,
        }
      },
    },
  )
}
